/**
 * Downloads a blob as a file with the specified filename
 * @param blob - The blob data to download
 * @param filename - The name of the file to download
 */
export const downloadFile = (blob: Blob, filename: string): void => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};

export interface UploadError {
    type: string;
    message: string;
    details: string | string[] | Record<string, string>;
}

/**
 * @param responseData - The response data from the API
 * @param defaultType - Default error type if not specified
 * @param defaultMessage - Default error message if not specified
 * @returns Parsed error object
 */

export const parseErrorResponse = (
    responseData: any, 
    defaultType: string = 'Unknown', 
    defaultMessage: string = 'An error occurred'
): UploadError => {
    try {
        let errorData;
        if (typeof responseData === 'string') {
            errorData = JSON.parse(responseData);
        } else {
            errorData = responseData;
        }

        if (errorData.error) {
            return errorData.error;
        } else if (errorData.type && errorData.message) {
            return errorData;
        } else {
            return {
                type: defaultType,
                message: defaultMessage,
                details: errorData.message || 'Unknown error occurred.'
            };
        }
    } catch (parseError) {
        return {
            type: defaultType,
            message: defaultMessage,
            details: 'Failed to parse error response.'
        };
    }
}; 